export enum EChallengeType {
  READING = "READING",
  WRITING = "WRITING",
}
